import * as React from "react";
import Context from "./Context";
import "./ButtonAdd.styl";

export default class ButtonAdd extends React.PureComponent {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({translate}) => (
                    <div className="Discussion-ButtonAdd-Root" onClick={() => {
                        const input = document.querySelector(".Discussion-Form-Input") as HTMLTextAreaElement;
                        input.focus();
                    }}>
                        <div className="Discussion-ButtonAdd-Label">
                            {translate("BUTTON_ADD")}
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

}